import React, { useContext } from "react";
import { useScrollToTop } from "@react-navigation/native";
import { createStackNavigator, RouterType } from "../../utils/routing";
import DrawerButton from "../../components/DrawerButton";
import Quiz from "../Quiz";
import QuizCta from "../../components/QuizCta";
import QuizQueue from "../../components/QuizQueue";
import { Background, Scroll, Intro } from "./styles";
import { FurnitureContext } from "../../utils/furniture";
import { Container, IntroPrompt, ReviewPrompt, Title } from "./styles";
import { useExternalState } from "../../utils/me";
import { QuizOrderContext } from "../../utils/quiz";
import { useTheme } from "@emotion/react";

const Stack = createStackNavigator(RouterType.Quiz);

const Navigator = () => {
    const theme: any = useTheme();
    return (
        <Stack.Navigator
            initialRouteName="MyRelationship"
            screenOptions={{
                headerShown: false,
                cardStyle: {
                    backgroundColor: theme?.color?.background,
                },
            }}>
            <Stack.Screen
                name="MyRelationship"
                component={MyRelationship}
                options={{ lazy: false }}
            />
            <Stack.Screen
                name="Quiz"
                component={Quiz}
                options={{ gestureEnabled: false }}
                getId={({ params }: { params: any }) => params.quizId}
            />
        </Stack.Navigator>
    );
};

const MyRelationship = ({ navigation }) => {
    const { myRelationshipScreen } = useContext(FurnitureContext);
    const { quizStates, logicStates } = useExternalState();
    const scrollViewRef = React.useRef(null);
    const { backgroundPattern }: any = useTheme();
    const quizOrder = useContext(QuizOrderContext);
    useScrollToTop(scrollViewRef);

    if (!quizStates || !logicStates || !quizOrder) {
        return <Container />;
    }

    return (
        <Container>
            <Background source={backgroundPattern} />
            <DrawerButton />
            <Scroll
                nativeID="my-relationship-scroll"
                ref={scrollViewRef}
                showsVerticalScrollIndicator={false}>
                <Title type="h3">{myRelationshipScreen.title}</Title>
                {quizOrder.completed?.length === 0 && (
                    <Intro type="mono2">
                        {myRelationshipScreen.beginningIntroduction}
                    </Intro>
                )}
                {!quizOrder.next && (
                    <Intro type="mono2">
                        {myRelationshipScreen.quizzesCompleted}
                    </Intro>
                )}
                {quizOrder.next && (
                    <QuizCta
                        quiz={quizOrder.next}
                        onPress={() =>
                            navigation.navigate("Quiz", {
                                quizId: quizOrder.next._id,
                                quizOrder,
                            })
                        }
                    />
                )}
                {quizOrder.completed?.length === 0 && (
                    <IntroPrompt type="h8">
                        {myRelationshipScreen.introPrompt}
                    </IntroPrompt>
                )}
                {quizOrder.queue?.length > 0 && (
                    <QuizQueue
                        queue={quizOrder.queue}
                        isDisabled={quizOrder.completed?.length === 0}
                        onPressItem={quizId =>
                            navigation.navigate("Quiz", {
                                quizId,
                                quizOrder,
                            })
                        }
                    />
                )}
                {quizOrder.completed?.length > 0 && (
                    <>
                        <ReviewPrompt type="h8">
                            {myRelationshipScreen.reviewPrompt}
                        </ReviewPrompt>
                        <QuizQueue
                            queue={quizOrder.completed}
                            quizStates={quizStates}
                            logicStates={logicStates}
                            onPressItem={quizId =>
                                navigation.navigate("Quiz", {
                                    quizId,
                                    isReview: true,
                                })
                            }
                            isComplete
                        />
                    </>
                )}
            </Scroll>
        </Container>
    );
};

export default Navigator;
